import { IRootState } from '../../../store'
import { ICmsInformationOptionsState } from '../store/options.types'

export const getCmsInformationOptionsSelector = (state: IRootState): ICmsInformationOptionsState =>
  state.options.cmsInformationOptions
